import { BILLING_EVENT_TYPES, STRIPE_INVOICE_STATUS, SUBSCRIPTION_INTERVAL } from "shared/enums/common.enum";
import { Company } from "../companies/company";
import { Subscription } from "../subscriptions/subscription";

export class PaymentHistory {
    id!: string;
    eventType!: BILLING_EVENT_TYPES;
    status!: string;
    description!: string;
    amount!: string;
    currency!: string;
    billingInterval!: SUBSCRIPTION_INTERVAL;
    billingPeriod!: SUBSCRIPTION_INTERVAL;
    additionalUsers!: number;
    additionalWarehouses!: number;
    userUnitPrice!: string;
    warehouseUnitPrice!: string;
    stripeInvoiceId!: string | null;
    stripePaymentIntentId!: string | null;
    periodStart!: string | null;
    periodEnd!: string | null;
    companyId!: string;
    companySubscriptionId!: string;
    subscriptionId!: string;
    subscriptionName!: string;
    createdAt!: string;
    updatedAt!: string;
    company!: Company;
    subscription!: Subscription;
    metadata!: SubscriptionEventMetadataDto;
    invoicePdfUrl!: string | null;
    hostedInvoiceUrl: string | null = null;
    invoiceStatus: STRIPE_INVOICE_STATUS | null = null;
    changes: BillingHistoryChange[] = [];
    effectiveDate: string | null = null;
    effectiveDateLabel!: string;

    constructor(data: PaymentHistory){
        Object.assign(this, data);
        if(data.changes?.length) {
            this.changes = data.changes.map(i => new BillingHistoryChange(i));
        }
    }
}

export class SubscriptionEventMetadataDto {
    isTrial!: boolean;
    usersAdded!: number;
    previousUsers!: number;
    warehousesAdded!: number;
    previousWarehouses!: number;

    constructor(data?: Partial<SubscriptionEventMetadataDto>) {
        Object.assign(this, data);
    }
}

export enum BILLING_HISTORY_CHANGE_ITEM {
    WAREHOUSE = 'warehouse',
    USER = 'user',
    SERVICE_TRUCK = 'serviceTruck'
}

export enum BILLING_HISTORY_CHANGE_ACTION {
    REMOVED = 'removed'
}

export class BillingHistoryChange {
    item!: BILLING_HISTORY_CHANGE_ITEM;
    action!: BILLING_HISTORY_CHANGE_ACTION;
    quantity!: number;
    label!: string;

    constructor(data: BillingHistoryChange) {
        Object.assign(this, data);
    }
}